import { MouseEventHandler } from 'react';

import TextBaseFieldPlaceholder, {
  TextBaseFieldPlaceholderProps,
} from '@app/features/apply-react-signing/components/FieldSetupStep/Placeholders/TextBaseFieldPlaceholder';

export interface NameFieldPlaceholderProps extends Omit<TextBaseFieldPlaceholderProps, 'value'> {}

const defaultProps = {
  rootElementSize: null,
  onMouseDown(_event: MouseEventHandler<HTMLDivElement>) {},
};

function NameFieldPlaceholder(props: NameFieldPlaceholderProps) {
  return <TextBaseFieldPlaceholder {...props} value="#서명자 이름" />;
}

NameFieldPlaceholder.defaultProps = defaultProps;

export default NameFieldPlaceholder;
